import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const isCriticalCol = (gantt, t) => ({
  name: 'is_critical',
  label: 'Ruta Crítica',
  align: 'center',
  resize: true,
  width: '*',
  template: (activity) => {
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.is_critical;
    }
    const state = gantt.getState().drag_mode;

    if (state == 'resize' || state == 'move' || gantt.isEditingDrag) {
      return '';
    }

    const hasChild = gantt.hasChild(activity.id);
    // activity.is_critical = gantt.isCriticalTask(activity) ? 'Si' : 'No'
    const render =
      activity.is_critical === 'Si' && t('lang') !== 'es'
        ? 'Yes'
        : activity.is_critical;
    return `
            <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
            color: #121212;">
                ${render}
            </div>
            `;
  },
  data_type: 'array/string',
  hide: !isColumnVisibleByDefault('is_critical'),
  from_values: [
    {
      color: 'lightgrey',
      value: 'No',
      label: 'No',
      weigth: 3
    },
    {
      color: 'darkturquoise',
      value: 'Si',
      label: t('lang') !== 'es' ? 'Yes' : 'Si',
      weigth: 2
    }
  ],
  groupable: false,
  orderable: false,
  orderable_switch: ['1 → 9', '9 → 1'],
  filterable: true
});

export default isCriticalCol; 